export const words: string[] = [
  'abuso',
  'cabrón',
  'capullo',
  'carajo',
  'coño',
  'filisteo',
  'hijo de perra',
  'hijo de puta',
  'hostia',
  'infierno',
  'joder',
  'joder a tu abuela',
  'joder a tu abuelo',
  'joder a tu familia',
  'joder a tu hermana',
  'joder a tu hermano',
  'joder a tu madre',
  'joder a tu mamá',
  'joder a tu padre',
  'joder a tu papá',
  'joder a tus padres',
  'jodido',
  'jódete',
  'maldita sea',
  'maldito',
  'maldito seas',
  'mamada',
  'mamón',
  'marica',
  'maricón',
  'mierda',
  'pendejo',
  'perra',
  'propagación de rumores',
  'puta',
  'que te den',
  'que te den por culo',
  'que te follen',
  'que te jodan',
  'sitio para adultos',
  'sitio pornográfico',
  'vete a la mierda',
  'vete a tomar por culo',
  'vete al infierno',
  'violación',
  'asno',
  'bastardo',
  'Bollera',
  'Chupada',
  'Chupapollas',
  'Chupetón',
  'concha',
  'Concha de tu madre',
  'Culo',
  'Fiesta de salchichas',
  'Follador',
  'Follar',
  'Gilipichis',
  'Hacer una paja',
  'Haciendo el amor',
  'Heroína',
  'Hija de puta',
  'Hijaputa',
  'Hijoputa',
  'Jilipollas',
  'Kapullo',
  'Lameculos',
  'Mariconazo',
  'martillo',
  'Nazi',
  'Pervertido',
  'Pinche',
  'Racista',
  'Soplagaitas',
  'Soplapollas',
  'Sádico',
  'Travesti',
  'Trio',
];
